import { LargeClickableTitle } from "components/ListTemplate/LargeClickableTitle";
import { ListTemplateLayout } from "components/ListTemplate/types";
import { BankAccountSidePanel } from "components/SidePanel/BankAccount/BankAccountSidePanel";
import React from "react";

const FormattedBankAccount = (props: { bankAccount: server.dto.BankAccount }) => {
  return <div className="bank-account-grid">
    {props.bankAccount.formatted.map((line, idx) => {
      return <React.Fragment key={`${props.bankAccount.bankAccountId}_${idx}`}>
        <div className="bank-account-grid-label">{line.label}</div>
        <div>{line.value}</div>
      </React.Fragment>;
    })}
  </div>;
};

export const cardLayout = (): ListTemplateLayout<server.dto.BankAccount> => ({
  type: "card",
  sections: {
    renderTitle: () => null,
    hideTitle: () => true,
    renderBody: item => <div className="padding-left padding-top-small flex-column gap">
      <BankAccountSidePanel
        bankAccountId={item.bankAccountId}
        trigger={<LargeClickableTitle
          icon={undefined}
          title={item.title}
        />}
      />
      <FormattedBankAccount bankAccount={item} />
    </div>,
    renderFooter: () => null,
    hideFooter: () => true
  }
});